import { ScreenNames } from '@hrms/common/routes/screens';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { ModuleConstants } from '@hrms/common/constant/modules';
import { generateImage } from '@hrms/common/utils/generateImage';

export enum RouteConstantEnums {
  GRIEVANCE_MANAGEMENT,
}

export const RouteConstantsInterface = {
  GRIEVANCE_MANAGEMENT: '/grievance-management',
  GRIEVANCE_DETAIL: '/grievance-management/:ticketId',
};
const getGrievanceModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.GRIEVANCE_MANAGEMENT,
      route: RouteConstantsInterface.GRIEVANCE_MANAGEMENT,
      title: ScreenNames.GRIEVANCE_MANAGEMENT,
      icon: generateImage({
        noScale: true,
        name: 'grievance',
        alt: 'grievance',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.GRIEVANCE_MANAGEMENT,
      children: [
        {
          id: ModuleConstants.GRIEVANCE_DETAIL,
          route: RouteConstantsInterface.GRIEVANCE_DETAIL,
          title: ScreenNames.GRIEVANCE_DETAILS,
          component: ComponentsMap.GRIEVANCE_DETAILS,
          sidebarVisibility: false,
        },
      ],
    },
  ];
};

export default getGrievanceModuleRoutes;
